module.exports = __webpack_public_path__ + "static/img/r_021.9610647.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_021.jpg
// module id = LuqK
// module chunks = 1